import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="12"
      height="21"
      viewBox="0 0 12 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41 10.59L5 14.17V0H7V14.17L10.59 10.58L12 12L6 18L0 12L1.41 10.59ZM0 19H12V21H0V19Z"
        fill="#0B78D0"
      />
    </svg>
  );
};

export default DownloadIcon;
